import { FeatureToggleEnum, featureToggleHelpers } from '@nocowanie/core';

import { parseCookies } from './cookie.helpers';

export const ftInitialState: Partial<Record<FeatureToggleEnum, unknown>> = {
    [FeatureToggleEnum.USE_NEW_CALENDAR]: true,
    [FeatureToggleEnum.USE_V7_THEME]: false,
};

// In common UI components and web components, we don't have access to the FeatureToggle state, so we have to retrieve by this helper.
export const getFeatureToggleValue = <T = unknown>(featureToggle: FeatureToggleEnum): T => {
    if (typeof window === 'undefined') {
        return false as T;
    }

    const cookies = parseCookies(document.cookie);
    return (
        cookies[featureToggle]
            ? featureToggleHelpers.FeatureToggleValueParserMap[featureToggle](
                  cookies[featureToggle],
              )
            : ftInitialState[featureToggle]
    ) as T;
};
